module.exports = __webpack_public_path__ + "static/media/blue-heart.abaea1ea.svg";